<template>
    <div class="login-container">
        <div class="login-card">
            <!-- Header -->
            <div class="login-header">
                <div class="logo">
                    <div class="logo-icon">🏣</div>
                    <h1>SIGN UP</h1>
                </div>
                <p class="subtitle">Create an account</p>
            </div>

            <!-- Login Form -->
            <form @submit.prevent="handleSignup" class="login-form">
                <div class="form-group">
                    <label for="firstname">First Name</label>
                    <div class="input-container">
                        <span class="input-icon">👤</span>
                        <input type="text" id="firstname" v-model="form.firstname" placeholder="Enter firstname"
                            required />
                    </div>
                </div>
                <div class="form-group">
                    <label for="lastname">Last Name</label>
                    <div class="input-container">
                        <span class="input-icon">👤</span>
                        <input type="text" id="lastname" v-model="form.lastname" placeholder="Enter lastname"
                            required />
                    </div>
                </div>
                <div class="form-group">
                    <label for="mobile">Email</label>
                    <div class="input-container">
                        <span class="input-icon">📧</span>
                        <input type="email" id="mobile" v-model="form.mobile" placeholder="Enter email" required />
                    </div>
                </div>

                <div class="form-group">
                    <label for="password">Password</label>
                    <div class="input-container">
                        <span class="input-icon">🔒</span>
                        <input :type="showPassword ? 'text' : 'password'" id="password" v-model="form.password"
                            placeholder="Enter your password" required />
                        <button type="button" class="password-toggle" @click="showPassword = !showPassword">
                            {{ showPassword ? "👁️" : "👁️‍🗨️" }}
                        </button>
                    </div>
                </div>
                <div class="form-group">
                    <label for="password">Confirm Password</label>
                    <div class="input-container">
                        <span class="input-icon">🔒</span>
                        <input :type="showPassword ? 'text' : 'password'" id="confirmpassword"
                            v-model="form.confirmpassword" placeholder="Confirm your password" required />
                        <button type="button" class="password-toggle" @click="showPassword = !showPassword">
                            {{ showPassword ? "👁️" : "👁️‍🗨️" }}
                        </button>
                    </div>
                </div>


                <div class="form-group">
                    <p v-if="errmsg !== null" class="text-danger">{{ errmsg }}</p>
                </div>
                <button type="submit" class="login-btn" :disabled="loading">
                    <span v-if="loading" class="spinner"></span>
                    <span v-else>Submit</span>
                </button>
            </form>

            <!-- Footer -->
            <div class="login-footer">
                <p>Already have an account? <router-link to="/login" class="signup-link">Sign in</router-link></p>
            </div>
        </div>

        <!-- Background Elements -->
        <div class="floating-element element-1"></div>
        <div class="floating-element element-2"></div>
        <div class="floating-element element-3"></div>
    </div>
</template>

<script setup>
import router from "@/router";
import authService from "@/services/auth.service";
import toastService from "@/services/toastService";
import { ref, reactive } from "vue";

const form = reactive({
    mobile: "",
    password: "",
    rememberMe: false,
});

const showPassword = ref(false);
const loading = ref(false);
const errmsg = ref(null);
const handleSignup = async () => {
    errmsg.value = null;
    loading.value = true;
    try {
        const resp = await authService.signup({ firstname: form.firstname, lastname: form.lastname, password: form.password, confirmpassword: form.confirmpassword, email: form.email });
        resp;
        router.push("/user/complete-profile")
    } catch (error) {
        errmsg.value = error.error ? error.error.message : "Server is unreachable";
        //console.log(error);
        toastService.error(errmsg.value);
    } finally {
        loading.value = false;
        //console.log('Login attempt with:', form)
    }
};
</script>

<style scoped>
.login-container {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #ea6666 0%, #a26e4b 100%);
    padding: 20px;
    position: relative;
    overflow: hidden;
}

.login-card {
    background: white;
    padding: 40px;
    border-radius: 20px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 420px;
    position: relative;
    z-index: 2;
    backdrop-filter: blur(10px);
}

.login-header {
    text-align: center;
    margin-bottom: 30px;
}

.logo {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    margin-bottom: 8px;
}

.logo-icon {
    font-size: 2rem;
}

h1 {
    color: #2d3748;
    font-size: 1.8rem;
    font-weight: 700;
    margin: 0;
}

.subtitle {
    color: #718096;
    margin: 0;
    font-size: 0.95rem;
}

.login-form {
    margin-bottom: 25px;
}

.form-group {
    margin-bottom: 20px;
}

label {
    display: block;
    margin-bottom: 8px;
    color: #2d3748;
    font-weight: 500;
    font-size: 0.9rem;
}

.input-container {
    position: relative;
    display: flex;
    align-items: center;
}

.input-icon {
    position: absolute;
    left: 15px;
    font-size: 1.1rem;
    z-index: 1;
}

input {
    width: 100%;
    padding: 12px 45px 12px 45px;
    border: 2px solid #e2e8f0;
    border-radius: 12px;
    font-size: 1rem;
    transition: all 0.3s ease;
    background: #f8fafc;
}

input:focus {
    outline: none;
    border-color: #b6300f;
    background: white;
    box-shadow: 0 0 0 3px rgba(182, 48, 15, 0.1);
}

.password-toggle {
    position: absolute;
    right: 15px;
    background: none;
    border: none;
    font-size: 1.1rem;
    cursor: pointer;
    padding: 0;
}

.form-options {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 25px;
}

.checkbox-container {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 0.9rem;
    color: #4a5568;
}

.checkbox-container input {
    display: none;
}

.checkmark {
    width: 18px;
    height: 18px;
    border: 2px solid #cbd5e0;
    border-radius: 4px;
    margin-right: 8px;
    position: relative;
    transition: all 0.3s ease;
}

.checkbox-container input:checked+.checkmark {
    background: #b6300f;
    border-color: #b6300f;
}

.checkbox-container input:checked+.checkmark::after {
    content: "✓";
    color: white;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 12px;
}

.forgot-password {
    color: #b6300f;
    text-decoration: none;
    font-size: 0.9rem;
    font-weight: 500;
}

.forgot-password:hover {
    text-decoration: underline;
}

.login-btn {
    width: 100%;
    padding: 14px;
    background: linear-gradient(135deg, #b6300f, #d93814);
    color: white;
    border: none;
    border-radius: 12px;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
}

.login-btn:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(182, 48, 15, 0.3);
}

.login-btn:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

.spinner {
    width: 18px;
    height: 18px;
    border: 2px solid transparent;
    border-top: 2px solid white;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.divider {
    text-align: center;
    margin: 25px 0;
    position: relative;
}

.divider::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 1px;
    background: #e2e8f0;
}

.divider span {
    background: white;
    padding: 0 15px;
    color: #718096;
    font-size: 0.9rem;
}

.social-login {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    margin-bottom: 25px;
}

.social-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px;
    border: 2px solid #e2e8f0;
    border-radius: 12px;
    background: white;
    cursor: pointer;
    transition: all 0.3s ease;
    font-weight: 500;
}

.social-btn:hover {
    border-color: #b6300f;
    transform: translateY(-1px);
}

.login-footer {
    text-align: center;
}

.login-footer p {
    color: #718096;
    margin: 0;
    font-size: 0.9rem;
}

.signup-link {
    color: #b6300f;
    text-decoration: none;
    font-weight: 600;
}

.signup-link:hover {
    text-decoration: underline;
}

.floating-element {
    position: absolute;
    border-radius: 50%;
    background: linear-gradient(135deg, rgba(182, 48, 15, 0.1), rgba(106, 176, 76, 0.1));
    animation: float 6s ease-in-out infinite;
}

.element-1 {
    width: 100px;
    height: 100px;
    top: 10%;
    left: 10%;
    animation-delay: 0s;
}

.element-2 {
    width: 150px;
    height: 150px;
    bottom: 20%;
    right: 10%;
    animation-delay: 2s;
}

.element-3 {
    width: 80px;
    height: 80px;
    top: 60%;
    left: 5%;
    animation-delay: 4s;
}

@keyframes float {

    0%,
    100% {
        transform: translateY(0px) rotate(0deg);
    }

    50% {
        transform: translateY(-20px) rotate(180deg);
    }
}

@media (max-width: 480px) {
    .login-card {
        padding: 30px 20px;
    }

    .social-login {
        grid-template-columns: 1fr;
    }
}
</style>
